import React, { FC, useState } from "react";
import { Empty, Spin } from "antd";

import membersService from "@services/members.service";

import CheckCircle from "@assets/check-circle.svg";
import CheckFillCircle from "@assets/check-fill-circle.svg";
import { changeDateFormatinDescription, formatDisplayDate } from "@utils/helpers";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../constants/constants";

type TAlertsProps = {
  data: any;
  updateMarkStatus: any;
};

// type Alert = {
//   alertsReadCount: number;
//   alertsUnReadCount: number;
//   patientAlerts: any;
// };

const AlertsAction: FC<TAlertsProps> = ({ data, updateMarkStatus }: TAlertsProps) => {
  let alerts = data;
  const [loading, setLoading] = useState(false);
  const [alertSeen, updateAlertSeen] = useState();

  const markSeen = (item: any, idx: number, read: any, unRead: any) => {
    let alertId = item.alertId;
    let readCount = (read + 1);
    let unReadCount = (unRead - 1);
    setLoading(true);
    updateAlertSeen(alertId);
    let newAlerts = { ...alerts };
    membersService.updateAlert(alertId).subscribe({
      next: async () => {
        item.alertReadStatus = 'Y';
        newAlerts.patientAlerts[idx] = item;
        newAlerts.alertsReadCount = readCount;
        newAlerts.alertsUnReadCount = unReadCount;
        alerts = newAlerts;
        setLoading(false);
        updateMarkStatus(newAlerts);
      },
      error: () => {
        setLoading(false);
        console.log("some error occured");
      }
    });
  };

  // const alertDateTime = (dates: any, type: number) => {
  //   let date = new Date(dates);
  //   if (type === 1) {
  //     let day: any = date.getDate();
  //     if (day === 1 || day === 21 || day === 31) day = day + 'st';
  //     else if (day === 2 || day === 22) day = day + 'nd';
  //     else if (day === 3 || day === 23) day = day + 'rd';
  //     else day = day + 'th'
  //     if (date.getDate() < 10) day = '0' + day;
  //     let month: any = date.getMonth();
  //     switch (month) {
  //       case 0: month = 'Jan';
  //         break;
  //       case 1: month = 'Feb';
  //         break;
  //       case 2: month = 'Mar';
  //         break;
  //       case 3: month = 'Apr';
  //         break;
  //       case 4: month = 'May';
  //         break;
  //       case 5: month = 'June';
  //         break;
  //       case 6: month = 'July';
  //         break;
  //       case 7: month = 'Aug';
  //         break;
  //       case 8: month = 'Sept';
  //         break;
  //       case 9: month = 'Oct';
  //         break;
  //       case 10: month = 'Nov';
  //         break;
  //       case 11: month = 'Dec';
  //         break;
  //     }
  //     return day + ' ' + month;
  //   };
  //   if (type === 2) {
  //     let hour: any = date.getHours();
  //     if (hour === 0) hour = '12';
  //     else if (hour < 10) hour = '0' + hour;
  //     let minute: any = date.getMinutes();
  //     if (minute < 10) minute = '0' + minute;
  //     let ampm = '';
  //     if (date.getHours() < 12) ampm = 'am';
  //     return hour + ':' + minute + ' ' + ampm;
  //   };
  // };

  return (
    <div className="alert-action-wrapper">
      <div className="alert-header-wrapper">
        <h1 className="alert-popup-title" style={{ color: "#ef6d2a" }}>
          All Alerts ({alerts?.patientAlerts.length})
        </h1>
      </div>
      <div className="alerts-list-container">
        {!alerts?.patientAlerts.length && <DataNotFound message={NO_DATA_FOUND} />}
        {alerts?.patientAlerts.map((item: any, idx: number) => {
          return (
            <div className="alert-content-wrapper" key={item.alertId}>
              <span className="alert-content">{changeDateFormatinDescription(item.alert)}</span>
              <div className="flex v-center">
                <span className="alert-time">
                  {/* {alertDateTime(item.alertDate, 1)} | {alertDateTime(item.alertDate, 2)} */}
                  {formatDisplayDate(item.alertDate, "reminderDateActualFormat", "shortDateFormatWithYear", true)}
                </span>
                <div
                  className={`ml-auto ${item.alertReadStatus === 'Y' ? "marked" : "mark-seen"
                    }`}
                >
                  {/* <span className="icon-check-circle f18  " style={{marginRight:"5px"}}/> */}
                  {item.alertReadStatus === 'Y' ? (
                    <>
                      <img
                        src={CheckFillCircle}
                        className="marked-icon"
                        alt="check-circle"
                      />
                      <span className="marked-label">Seen</span>
                    </>
                  ) : (
                    <Spin spinning={loading && item.alertId === alertSeen} indicator={<HealthemSpinner/>}>
                      <div className="mark-seen-alert" onClick={() => markSeen(item, idx, alerts.alertsReadCount, alerts.alertsUnReadCount)} >
                        <img
                          src={CheckCircle}
                          className="marked-icon"
                          alt="check-circle"
                        />
                        <span className="mark-alert"
                          >
                          Mark Seen
                        </span>
                      </div>
                    </Spin>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default AlertsAction;
